import styled from 'styled-components';

export const getTabStyles = (theme) => ({
  font: theme.fonts.textSmallWeight700Height16Bold,
  '&.Mui-selected': {
    color: theme.colors.greys.darkest,
  },
});

export const Container = styled.div`
  display: flex;
  flex-direction: column;
  width: 100%;
  height: calc(100% - 40px);
`;

export const DataGridContainer = styled.div`
  display: flex;
  flex-direction: column;
  width: 100%;
  height: 100%;
  background-color: ${({ theme }) => theme.colors.greys.lightest};
  border-radius: 12px;
  border: 1px solid ${({ theme }) => theme.colors.greys.light};
`;

export const DataGridHeader = styled.div`
  display: flex;
  justify-content: space-between;
  align-items: center;
  padding: 8px 16px;
  border-bottom: 1px solid ${({ theme }) => theme.colors.greys.light};
`;

export const DataGridHeaderTextContainer = styled.div`
  display: flex;
  flex-direction: row;
  align-items: center;
  gap: 16px;
`;

export const ExportModalContainer = styled.div`
  display: flex;
  align-items: center;
  justify-content: center;
  flex-direction: column;
  gap: 24px;
  padding-bottom: 48px;
`;
